import React, { useState, useEffect } from 'react';
import qs from 'query-string';
import { withSnackbar } from 'notistack';

import './style.scss';
import LoadingModal from '../../../../components/atoms/LoadingModal';
import {
  ScreenTitle,
  QuestionResult,
  Question,
} from '../../../../components/atoms';
import { Strings } from '../../../../shared/constants/Constants';
import MessageModal from '../../../../components/molecules/MessageModal';
import {
  achievement_3_details,
  achievementName_3,
  achievement_4_details,
  achievementName_4,
  achievement_9_details,
  achievement_5_details,
  achievementName_5,
} from '../../../../shared/constants/AchievementConstants';
import { ROUTE_CONSTANTS } from '../../../../shared/constants/Route';

let questionDetails = {};
let route = ROUTE_CONSTANTS.QUESTIONS;

const QuestionScreen = ({
  state,
  userId,
  sessionToken,
  subtopicId,
  loading,
  enqueueSnackbar,
  history,
  getQuestionByTopicId = () => {
  },
  hideQuestion = () => {
  },
  submitTestResponse = () => {
  },
  submit_unlocked_achievement = () => {
  },
  achievement_unlocked = () => {
  },
}) => {
  let { query: { sub_topic_id = ' ', question_index = '' } = {} } = qs.parseUrl(
    window.location.href,
  );
  const [activeQuestionIndex, setActiveQuestionIndex] = useState(0);
  const [selectedAnswer, setSelectedAnswer] = useState(-1);
  const [showAnswer, setShowAnswer] = useState(false);
  const [questions, setQuestions] = useState([]);
  const [showPurchaseModal, setShowPurchaseModal] = useState(false);
  const [showAchievementModal, setShowAchievementModal] = useState(false);
  const [showSubmitModal, setShowSubmitModal] = useState(false);
  const [answerTitle, setAnswerTitle] = useState('');
  const [ansDescription, setAnswerDescription] = useState('');
  const [result, setResult] = useState('');
  const [category, setCategory] = useState('');
  const [disableContinue, setDisableContinue] = useState(false);
  const [achievementDetailsText, setAchievementText] = useState('');
  const [achievementName, setAchievementName] = useState('');
  const [submitMessage, setSubmitMessage] = useState('');
  let oldAttemptedQuestion = 0;

  useEffect(() => {

    fetchQuestions();
    achievement_unlocked('when_25_questionsAnswered', 0);
    achievement_unlocked('allquestionsAnswered', 0);
    oneTimeProcessForNewQuestion();

    // return () => {
    //   submitQuestionData(false);
    // };
  }, []);

  const fetchQuestions = () => {
    const questionBody = {
      userId: userId,
      sessionToken: sessionToken,
      categoryId: sub_topic_id,
    };
    getQuestionByTopicId(questionBody, question_index, (message, type) => {
      enqueueSnackbar(message, {
        variant: type,
        autoHideDuration: 3000,
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'left',
        },
      });
    });
  };

  useEffect(() => {
    setQuestions(state.QuestionReducer.questionList);
    if (state.QuestionReducer.questionList.length > 0) {
      setCategory(state.QuestionReducer.questionList[0].cateName);
    }
  }, [state.QuestionReducer.questionList]);

  const selectAnswer = (selectedAnswerIndex) => {
    setSelectedAnswer(selectedAnswerIndex);
  };
  const hideAchievementModal = () => {
    setShowAchievementModal(false);

    if (achievementName) {

      submit_unlocked_achievement({
        userId,
        sessionToken,
        achievement_type: achievementName,
      });
    }
  };

  const hideTheQuestion = () => {
    const { qid } = questions[activeQuestionIndex];
    const questionResponseData = {
      qid,
      responseType: result,
      isHidden: true,
    };
    const hiddenQuestion = [];
    hiddenQuestion.push(questionResponseData);
    const currQuestions = [...questions];
    currQuestions[activeQuestionIndex] = questionResponseData;
    setQuestions(currQuestions);
    const questionData = {
      userId,
      sessionToken,
      subTopicId: questionDetails.subTopicId,
      topicId: questionDetails.topicId,
      questionArray: hiddenQuestion,
    };
    hideQuestion(questionData, (message, type) => {
      if (type === '') {
        changeQuestion();
      } else {
        enqueueSnackbar(message, {
          variant: type,
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left',
          },
        });
      }
    });
  };

  const submitAnswer = (res) => {
    const { qid } = questions[activeQuestionIndex];

    const questionResponseData = {
      qid,
      responseType: res ? Strings.CORRECT_ANSWER : Strings.INCORRECT_ANSWER,
      isHidden: false,
    };
    const questionArray = [...questions];

    questionArray[activeQuestionIndex] = questionResponseData;
    setQuestions(questionArray);
  };

  const oneTimeProcessForNewQuestion = () => {

    try {
      if (state.QuestionReducer.subtopicList.length) {
        oldAttemptedQuestion = parseInt(
          state.QuestionReducer.subtopicList[0].hidden_question_count,
        );
      }
    } catch {
      oldAttemptedQuestion = 0;
    }
  };

  const changeQuestion = () => {
    if (activeQuestionIndex < state.QuestionReducer.questionList.length - 1) {
      setActiveQuestionIndex((prevState) => prevState + 1);
      setShowAnswer(false);
      oneTimeProcessForNewQuestion();
    } else {
      setDisableContinue(true);
      submitQuestionData(false);
    }
  };

  const goForward = () => {
    const options = [
      questions[activeQuestionIndex].ans1,
      questions[activeQuestionIndex].ans2,
      questions[activeQuestionIndex].ans3,
      questions[activeQuestionIndex].ans4,
    ];
    const {
      correctAnswer,
      answerDescription,
      incorrectDescription,
    } = questions[activeQuestionIndex];
    let res = false;

    if (correctAnswer === options[selectedAnswer]) {
      setAnswerTitle(Strings.youAreCorrect);
      setAnswerDescription(answerDescription);
      setResult(Strings.CORRECT_ANSWER);

      res = true;
    } else {
      setAnswerTitle(Strings.thatsNotCorrect);
      setAnswerDescription(incorrectDescription);
      setResult(Strings.INCORRECT_ANSWER);
    }
    setShowAnswer(true);
    setSelectedAnswer(-1);
    submitAnswer(res);

    // First question answered
    if (!state.CommonReducer.firstQuestionAnswered) {
      setAchievementText(achievement_3_details);
      setAchievementName(achievementName_3);
      achievement_unlocked('firstQuestionAnswered', true);
      setShowAchievementModal(true);

      state.CommonReducer.unlockedAchievementArray[2] = true;
    }
    // First correct answer
    if (!state.CommonReducer.firsrQuestionCorrectlyAnswered && res) {
      setAchievementText(achievement_4_details);
      setAchievementName(achievementName_4);
      achievement_unlocked('firsrQuestionCorrectlyAnswered', true);
      setShowAchievementModal(true);
      state.CommonReducer.unlockedAchievementArray[3] = true;
    }

    /* 25 qestions are answered */
    if (state.CommonReducer.when_25_questionsAnswered === 24) {
      setAchievementText(achievement_9_details);
      achievement_unlocked('when_25_questionsAnswered', 0);
      // state.CommonReducer.when_25_questionsAnswered = 0;
      setShowAchievementModal(true);
    } else {
      achievement_unlocked(
        'when_25_questionsAnswered',
        state.CommonReducer.when_25_questionsAnswered + 1,
      );
    }

    /*all question answered */
    let totalQuestions = state.QuestionReducer.questionList.length;
    if (state.CommonReducer.allquestionsAnswered === totalQuestions - 1) {
      setAchievementText(achievement_5_details);
      setAchievementName(achievementName_5);
      achievement_unlocked('allquestionsAnswered', 0);
      setShowAchievementModal(true);

      state.CommonReducer.unlockedAchievementArray[4] = true;
    } else {
      achievement_unlocked(
        'allquestionsAnswered',
        state.CommonReducer.allquestionsAnswered + 1,
      );
    }

    /* purchase game status */
    if (state.CommonReducer.purchaseStatus === false) {
      if (oldAttemptedQuestion + activeQuestionIndex >= 5) {
        setDisableContinue(true);
        setShowPurchaseModal(true);
      }
    } else {
      if (state.LoginReducer.isNetConnected) {
        // state.TopicsReducer.showTopicList = true;
        // this.upDatingQuestion();
      } else {
        // Alert.alert(APP_NAME, INTERNET_CHECK);
      }
    }
  };

  const submitQuestionData = (back) => {
    setShowPurchaseModal(false);
    // let questionArray = this.state.questionsDetailArray;

    let question = questions.filter((item) => item.isHidden === false);

    // const { topicId, subTopicId } = questions[activeQuestionIndex];
    // const { qid } = questions[activeQuestionIndex];

    // const questionResponseData = {
    //   qid,
    //   responseType: Strings.CORRECT_ANSWER,
    //   isHidden: false,
    // };
    // const questionArray = [{ ...questionResponseData }];

    const questionData = {
      userId,
      sessionToken,
      subTopicId: questionDetails.subTopicId,
      topicId: questionDetails.topicId,
      questionArray: question,
    };
    submitTestResponse(questionData, back, (message, type) => {
      if (type !== '') {
        history.push(ROUTE_CONSTANTS.QUESTIONS);
        enqueueSnackbar(message, {
          variant: type,
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left',
          },
        });
      } else {
        if (message !== '') {
          setSubmitMessage(message);
          setShowSubmitModal(true);
        }
      }
    });
  };

  const renderButtons = () => {
    if (showAnswer) {
      return (
        <div className='d-flex mt-3 result-btn-container'>
          <button className='not-see-question-btn' onClick={hideTheQuestion}>
            {Strings.notSeeQuestionAgain}
          </button>
          <button
            className={`blue-btn ${disableContinue ? 'disabled-btn' : ''}`}
            disabled={disableContinue}
            onClick={() => {
              changeQuestion();
            }}
          >
            {Strings.continue}
          </button>
        </div>
      );
    }
    return (
      <button
        className={`blue-btn mt-4 submit-btn ${
          selectedAnswer === -1 ? 'disabled-btn' : ''
        }`}
        onClick={goForward}
        disabled={selectedAnswer === -1}
      >
        {Strings.submitAnswer}
      </button>
    );
  };

  const hidePurchaseModal = (changeRoute) => {
    // setShowPurchaseModal(false);
    submitQuestionData(false);
    if (changeRoute) {
      route = ROUTE_CONSTANTS.QUESTIONS;
    } else {
      route = ROUTE_CONSTANTS.PURCHASE_P2P;
    }
    // history.push(ROUTE_CONSTANTS.QUESTIONS);
  };

  const hideSubmitModal = () => {
    // setShowSubmitModal(false);
    // submitQuestionData(false);
    // history.push(ROUTE_CONSTANTS.QUESTIONS);
    history.push(route);
  };

  const renderQuestionConatiner = (questionData) => {
    questionDetails = questionData;
    return showAnswer === true ? (
      <>
        <QuestionResult
          answerTitle={answerTitle}
          answerDescription={ansDescription}
        />
      </>
    ) : (
      <>
        {questions.length > 0 && (
          <Question
            question={questions[activeQuestionIndex].question || ''}
            options={[
              questions[activeQuestionIndex].ans1,
              questions[activeQuestionIndex].ans2,
              questions[activeQuestionIndex].ans3,
              questions[activeQuestionIndex].ans4,
            ]}
            questionNumber={activeQuestionIndex + 1}
            selectedAnswer={selectedAnswer}
            selectAnswer={selectAnswer}
          />
        )}
      </>
    );
  };
  return (
    <>
      {showSubmitModal && (
        <MessageModal
          title={'Prep 2 Pass'}
          icon='tick.png'
          message={submitMessage}
          callback={hideSubmitModal}
        />
      )}
      {showAchievementModal && (
        <MessageModal
          title={'Achievement Unlocked!'}
          message={achievementDetailsText}
          icon='trophy.png'
          callback={hideAchievementModal}
        />
      )}
      {showPurchaseModal && (
        <MessageModal
          title={Strings.purchaseTitle}
          message={Strings.purchaseMessage}
          callback={() => hidePurchaseModal(true)}
          render={() => {
            return (
              <button
                style={{
                  background: '#fff',
                  border: '1.25px solid #7ebf41',
                  color: '#7ebf41',
                  padding: '.65rem 2rem',
                  borderRadius: '5px',
                  fontWeight: 'bolder',
                  marginTop: '1rem',
                  cursor: 'pointer',
                }}
                onClick={() => {
                  hidePurchaseModal(false);
                }}
              >
                Okay
              </button>
            );
          }}
        />
      )}
      <ScreenTitle title='Topics > Sub Topics' subTitle={category}/>
      {loading ? (
        <LoadingModal isVisible={loading}/>
      ) : (
        <>
          <div className='question-container'>
            {state.QuestionReducer.questionList.length > 0
              ? renderQuestionConatiner(
                state.QuestionReducer.questionList[activeQuestionIndex],
              )
              : null}
          </div>
          {renderButtons()}
        </>
      )}
    </>
  );
};

export default withSnackbar(QuestionScreen);
